/**
 * @module beebee-base/lib/utility/_shared
 * @description Shared constants used across multiple utility sub-modules.
 *
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      lib util — shared constants for lib/utility/* sub-modules
 *   extends:   -
 *   template:  none
 *   args:      -
 *   uses:      -
 *   siblings:  sibling lib/utility/*.js modules (all re-exported via ../utility.js barrel)
 *   tests:     utility-extra-test.js
 */

/** Lista valute supportate */
const listCurrency = Object.freeze(['AUD', 'CAD', 'EUR', 'GBP', 'CHF', 'USD']);

export { listCurrency };
//# sourceMappingURL=_shared.js.map
